module.exports = __webpack_public_path__ + "static/img/13.0f5881b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fg/13.png
// module id = 130
// module chunks = 2